
export const TextField = (props) => {
  let { name, title, onChange, type, children, placeholder } = props;
  if (!type) type = "text";

  const onTextChanged = (e) => {
    onChange(e.target.value);
  };
  
  const renderTitle = () => {
    if(title){
      return <label htmlFor={name}>{title}</label>
    }
  }

  return (
    <div className={`text-field text-field-${name}`}>
      {renderTitle()}
      {children ? (
        children
      ) : (
        <input
          {...props}
          onChange={onTextChanged}
          placeholder={placeholder}
          className={`text-field-input-${name}`}
        />
      )}
    </div>
  );
};
